export default {"src":"/_next/static/media/linkedInBuilding.fca09430.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};